// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "57d62b62" + "." + "f88f729419d736c5" + ".js";
};